package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.SportsBaseballW500Rounded: ImageVector
    get() {
        if (_sportsBaseballW500Rounded != null) {
            return _sportsBaseballW500Rounded!!
        }
        _sportsBaseballW500Rounded = Builder(name = "SportsBaseballW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(226.87f, 670.8f)
                quadToRelative(44.52f, -35.0f, 69.42f, -84.6f)
                quadToRelative(24.91f, -49.61f, 24.91f, -106.17f)
                quadToRelative(0.0f, -56.55f, -24.91f, -106.19f)
                quadToRelative(-24.9f, -49.64f, -69.42f, -84.64f)
                quadToRelative(-31.0f, 41.73f, -47.5f, 90.43f)
                quadToRelative(-16.5f, 48.69f, -16.5f, 100.37f)
                quadToRelative(0.0f, 51.68f, 16.5f, 100.37f)
                quadToRelative(16.5f, 48.7f, 47.5f, 90.43f)
                close()
                moveTo(584.47f, 779.99f)
                quadToRelative(50.66f, -17.14f, 92.42f, -51.19f)
                quadToRelative(-56.28f, -46.0f, -87.42f, -111.02f)
                reflectiveQuadTo(558.33f, 480.0f)
                quadToRelative(0.0f, -72.76f, 31.14f, -137.78f)
                reflectiveQuadToRelative(87.42f, -111.02f)
                quadToRelative(-41.76f, -34.05f, -92.39f, -51.19f)
                quadToRelative(-50.64f, -17.14f, -104.71f, -17.14f)
                quadToRelative(-54.07f, 0.0f, -104.62f, 17.26f)
                quadToRelative(-50.54f, 17.26f, -92.3f, 51.3f)
                quadToRelative(56.28f, 46.0f, 87.3f, 111.05f)
                quadToRelative(31.03f, 65.05f, 31.03f, 137.55f)
                quadToRelative(0.0f, 72.49f, -31.03f, 137.51f)
                quadToRelative(-31.02f, 65.03f, -87.3f, 111.03f)
                quadToRelative(41.76f, 34.04f, 92.34f, 51.3f)
                quadToRelative(50.57f, 17.26f, 104.58f, 17.26f)
                reflectiveQuadToRelative(104.68f, -17.14f)
                close()
                moveTo(733.47f, 671.28f)
                quadToRelative(30.9f, -41.76f, 47.28f, -90.58f)
                quadToRelative(16.38f, -48.83f, 16.38f, -100.65f)
                quadToRelative(0.0f, -51.81f, -16.38f, -100.69f)
                quadToRelative(-16.38f, -48.88f, -47.28f, -90.64f)
                quadToRelative(-44.86f, 35.0f, -70.0f, 84.88f)
                quadToRelative(-25.14f, 49.88f, -25.14f, 106.4f)
                reflectiveQuadToRelative(25.14f, 106.4f)
                quadToRelative(25.14f, 49.88f, 70.0f, 84.88f)
                close()
                moveTo(480.0f, 480.0f)
                close()
                moveTo(320.89f, 856.03f)
                quadToRelative(-74.43f, -32.1f, -129.63f, -87.29f)
                quadToRelative(-55.19f, -55.2f, -87.29f, -129.65f)
                quadToRelative(-32.1f, -74.46f, -32.1f, -159.11f)
                quadToRelative(0.0f, -84.65f, 32.1f, -159.09f)
                quadToRelative(32.1f, -74.43f, 87.29f, -129.63f)
                quadToRelative(55.2f, -55.19f, 129.65f, -87.29f)
                quadToRelative(74.46f, -32.1f, 159.11f, -32.1f)
                quadToRelative(84.65f, 0.0f, 159.09f, 32.1f)
                quadToRelative(74.43f, 32.1f, 129.63f, 87.29f)
                quadToRelative(55.19f, 55.2f, 87.29f, 129.65f)
                quadToRelative(32.1f, 74.46f, 32.1f, 159.11f)
                quadToRelative(0.0f, 84.65f, -32.1f, 159.09f)
                quadToRelative(-32.1f, 74.43f, -87.29f, 129.63f)
                quadToRelative(-55.2f, 55.19f, -129.65f, 87.29f)
                quadToRelative(-74.46f, 32.1f, -159.11f, 32.1f)
                quadToRelative(-84.65f, 0.0f, -159.09f, -32.1f)
                close()
            }
        }
        .build()
        return _sportsBaseballW500Rounded!!
    }

private var _sportsBaseballW500Rounded: ImageVector? = null
